/**
 * Waits for the specified cookie to be set.
 * @param cookieName - The name of the cookie to wait for.
 * @param maxWaitTime - The maximum wait time in milliseconds. Default is 10000.
 * @returns A promise that resolves if the cookie is set within the specified time,
 *          otherwise rejects with a timeout error.
 */
export const waitForCookie = (cookieName: string, maxWaitTime: number = 10000): Promise<void> =>
	new Promise((resolve, reject) => {
		let elapsedTime = 0
		const checkCookieInterval = setInterval(() => {
			if (document.cookie.includes(cookieName)) {
				clearInterval(checkCookieInterval)
				resolve()
			} else {
				elapsedTime += 1000
				if (elapsedTime >= maxWaitTime) {
					clearInterval(checkCookieInterval)
					reject(new Error('Timeout waiting for cookie'))
				}
			}
		}, 1000)
	})
